import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PendingApproval from '../pages/PendingApproval';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (user.status !== 'approved') return <PendingApproval />;
  return children;
}
